export default "__VITE_ASSET__1ecc9566__"